document.addEventListener("DOMContentLoaded", function () {
  if (window.matchMedia("screen and (min-width: 922px)").matches) {
    let carousel = document.querySelectorAll(".pp-carousel");
    console.log(carousel);

    carousel.forEach((car) => {
      console.log("CAR " + car);

      let flkty = new Flickity(car, {
        freeScroll: true,
        wrapAround: true,
        prevNextButtons: true,
        pageDots: false,
        cellAlign: "left",
      });
    });


    // if (carousel) {
    //   let flkty = new Flickity(carousel, {
    //     freeScroll: true,
    //     wrapAround: true,
    //     prevNextButtons: true,
    //     pageDots: false,
    //     cellAlign: "left",
    //   });
    // }
  } else {
    let ppLink = $('.product-slider__header-link');
    $('.pp-carousel').parent().append('<a href="' + ppLink.attr('href') + '" title="' + ppLink.attr('title') + '" class="product-slider__header-link wm-js-allmeal-btn">' + ppLink.text() + '</a>');
  }
});